import "core-js/stable";
import "regenerator-runtime/runtime";
import 'jquery';
import 'bootstrap';
require('bootstrap/dist/css/bootstrap.min.css');
require('../css/style.css');
